import { Component, ComponentInterface, h, Prop } from '@stencil/core';
import { guid, isOnScreen } from 'utils';

declare const assetPath;

@Component({
  tag: 'kdx-section-bg',
  styleUrl: 'kdx-section-bg.scss',
  shadow: false,
})
export class StSectionBg implements ComponentInterface {

	/**
	 * Background color for section. primary, secondary, tertiary, quarternary.
	 */
	@Prop() color: string = 'primary';

	/**
	 * Background image src for section. Overrides color.
	 */
	@Prop() bgImage: string;

	@Prop() bgRepeat?: string;

	/**
	 * Flag to enable fade in animation to section contents.
	 */
		@Prop() animateContent: boolean;
		
		/**
		 * Determines if the caption should extend to the edge of
		 * the section area or not
		 * 
		 * By default, standard gutter patting will be applied
		 */
		@Prop() isFullBleed: boolean;

	/**
	 * Aria label required for section elements
	 */
	@Prop() ariaLabel: string;

	/**
	 * Additional classes to append to the section wrapper
	 */
	@Prop() classes?: string;

	private id: string = 'kdx-section-bg-' + guid();
	private instance: HTMLElement = null;
	private didAnimate: boolean;

	componentDidRender() {
		if (this.animateIn) {
			this.triggerAnimation();
		}
	}

	/**
	 * Watch for section to come into view. Apply animations when it does.
	 */
	triggerAnimation() {
		this.instance = document.querySelector(`#${this.id}`);
		window.addEventListener('scroll', () => {
			if (isOnScreen(this.instance)) {
				this.animateIn();
			}
		});

		if (isOnScreen(this.instance)) {
			this.animateIn();
		}
	}

	/**
	 * Animate each column within a row in after each other.
	 */
	animateIn() {
		if (this.didAnimate) {
			return;
		}

		let colCount = 0;
		const rows = this.instance.querySelectorAll('.row');

		rows.forEach((row) => {
			for (let i = 0; i < row.children.length; i++) {
				setTimeout(() => {
					row.children[i].classList.add('animate-in');
				}, 300 * colCount);
				colCount += 1;
			}
		});

		this.didAnimate = true;
	}

	render() {
		let style = null;

		if (this.bgImage) {
		style = {
			backgroundImage: `url(${assetPath}${this.bgImage})`,
		};
		}

		return (
			<section 
				id={this.id} 
				class={`
					kdx-section-bg 
					bg-${this.color}
					${this.animateContent ? ' animate' : ''}
					${this.bgImage ? ' lazy-load-bg' : ''}
					${this.isFullBleed ? ' is-full-bleed' : ''}
					${this.classes ? ` ${this.classes}` : ''}`
				} 
				style={style}
				aria-label={this.ariaLabel}
				bg-repeat={this.bgRepeat}
			>
				<div class="container-fluid">
					<slot />
				</div>
			</section>
		);
	}

}
